'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002einserters$002e$002dDynamic$002dInserter from "./com.raquo.laminar.inserters.-Dynamic-Inserter.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction3$002e$0024$0024$002dLambda$002473f37e31ba038fe839c174212837da323f140c96 from "./scala.scalajs.runtime.-Anon-Function3.$$-Lambda$73f37e31ba038fe839c174212837da323f140c96.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildInserter$() {
}
export { $c_Lcom_raquo_laminar_inserters_ChildInserter$ as $c_Lcom_raquo_laminar_inserters_ChildInserter$ };
$p = $c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_ChildInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildInserter$() {
}
export { $h_Lcom_raquo_laminar_inserters_ChildInserter$ as $h_Lcom_raquo_laminar_inserters_ChildInserter$ };
$h_Lcom_raquo_laminar_inserters_ChildInserter$.prototype = $p;
$p.bA = (function(childSource, renderable, initialHooks) {
  return new $j_com$002eraquo$002elaminar$002einserters$002e$002dDynamic$002dInserter.$c_Lcom_raquo_laminar_inserters_DynamicInserter($j_java$002elang$002e$002dObject.$m_s_None$(), true, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction3$002e$0024$0024$002dLambda$002473f37e31ba038fe839c174212837da323f140c96.$c_sjsr_AnonFunction3_$$Lambda$73f37e31ba038fe839c174212837da323f140c96(((ctx, owner, hooks) => {
    if ((!ctx.jG)) {
      ctx.xh();
    }
    return $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(childSource, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((ctx$2, maybeLastSeenChild) => ((newComponent) => {
      this.XV(maybeLastSeenChild.aK, newComponent, ctx$2, hooks);
      var ev$3 = newComponent;
      maybeLastSeenChild.aK = ev$3;
      ev$3 = null;
    }))(ctx, new $j_java$002elang$002e$002dObject.$c_sr_ObjectRef((void 0)))), owner);
  })), initialHooks);
});
$p.XV = (function(maybeLastSeenChild, newChildNode, ctx, hooks) {
  if ((!ctx.jG)) {
    ctx.xh();
  }
  var elem = ctx.iE;
  var elem$1 = 0;
  elem$1 = elem;
  var x$1 = (((maybeLastSeenChild === (void 0)) || $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(maybeLastSeenChild.aV(), ctx.jF.aV().nextSibling)) ? maybeLastSeenChild : (void 0));
  if ((x$1 === (void 0))) {
    $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().xq(ctx.jE, newChildNode, ctx.jF, hooks);
  } else if (($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().X2(ctx.jE, x$1, newChildNode, hooks) || (x$1 === newChildNode))) {
    var ev$4 = ((elem$1 - 1) | 0);
    elem$1 = ev$4;
  }
  ctx.WX(newChildNode);
  ctx.hy.clear();
  ctx.hy.set(newChildNode.aV(), newChildNode);
  ctx.iE = 1;
});
var $d_Lcom_raquo_laminar_inserters_ChildInserter$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_inserters_ChildInserter$, "com.raquo.laminar.inserters.ChildInserter$", ({
  i6: 1
}));
export { $d_Lcom_raquo_laminar_inserters_ChildInserter$ as $d_Lcom_raquo_laminar_inserters_ChildInserter$ };
var $n_Lcom_raquo_laminar_inserters_ChildInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildInserter$;
}
export { $m_Lcom_raquo_laminar_inserters_ChildInserter$ as $m_Lcom_raquo_laminar_inserters_ChildInserter$ };
